import React, { useContext, useState } from 'react'
import { ServiceContext } from './ServiceContext'

export interface ServiceProviderProps {
    services: unknown[]
    children: React.ReactNode
}

const DocumentServiceProvider = ({ services, children }: ServiceProviderProps) => {
    const current = useContext(ServiceContext) || []

    // Deliberate mount-time snapshot (useState initializer, not useMemo):
    // callers pass inline `services` arrays, so tracking them as deps would
    // produce a new context value on every render and re-render all consumers.
    // The entries are stable references (MobX controllers, setState setters),
    // so live data flows through observation — the identities never need to
    // update after mount. If a caller ever needs dynamic services, memoize
    // the array at the call site and change this to track [services, current].
    const [value] = useState(() => [...services, ...current])

    return (
        <ServiceContext.Provider value={value}>
            {children}
        </ServiceContext.Provider>
    )
}

export { DocumentServiceProvider }

export const ServiceConsumer = ServiceContext.Consumer
